import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import voca from 'voca';
import { drapcodeIcon } from '../../common/custom/icon-library';
import types from '../../common/formElements/CollectionSectionType';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { uploadTypes } from '../../common/formElements/CollectionSectionType';
import csvImage from '../../images/collection/filetype-csv.svg';
import jsonImage from '../../images/collection/filetype-json.svg';

export class CollectionHeaderNav extends Component {
  showItemDataNav = () => {
    const {
      projectId,
      version,
      selectedCollection,
      // uploadHeaders
    } = this.props;
    const {
      uuid,
      collectionTitle,
      collectionName,
      // willPersist,
      // externalDatabaseId
    } = selectedCollection || '';

    // let showCollectionItems = true;
    // if (selectedCollection) {
    //   showCollectionItems = willPersist && !externalDatabaseId && !uploadHeaders ? true : false;
    // }

    //TODO: Need to Handle Non-Persistent Collection Item Data accessibility
    // if (showCollectionItems) {
    return (
      <li className={`nav-item`}>
        <Link
          to={`/collections/${version}/v/${projectId}/items/${uuid}/name/${collectionName}`}
          className="btn btn-theme-green btn-raised"
          title={`${collectionTitle ? collectionTitle + ' Data' : 'Collection Data'}`}
        >
          <i className={`wb ${drapcodeIcon('navigation')}`} size={'md'}></i>&nbsp;
          {voca.truncate(collectionTitle ? collectionTitle + ' Data' : 'Collection Data', 15)}
        </Link>
      </li>
    );
    // } else {
    //   return '';
    // }
  };

  render() {
    const {
      label,
      projectId,
      version,
      selectedCollection,
      loadProjectCollectionDetailPending,
      uploadHeaders,
    } = this.props;
    if (!selectedCollection) {
      return <div className="text-center"></div>;
    }
    const { uuid, collectionTitle, collectionName, restrictEdit } = selectedCollection || {};
    return (
      <nav className="navbar navbar-expand-lg bg-primary">
        <div className="container">
          <div className="navbar-translate">
            <div
              className="navbar-brand"
              title={`${collectionTitle ? collectionTitle : 'Collection'}`}
            >
              <i className="wb webconnect-stack" size={'md'}></i>&nbsp;
              <span>{voca.truncate(collectionTitle ? collectionTitle : 'Collection', 30)}</span>
            </div>
          </div>
          <div className="collapse navbar-collapse">
            <ul className="navbar-nav ml-auto">
              {this.showItemDataNav()}
              {uploadHeaders ? (
                <>
                  <li className={`nav-item ${label === uploadTypes.CSV && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/import-data/${uuid}`}
                      className="nav-link"
                      title="Import From CSV FILE"
                    >
                      <img src={csvImage} alt="csv" className="mb-1" />
                      &nbsp;CSV
                    </Link>
                  </li>
                  &nbsp; &nbsp;
                  <li className={`nav-item ${label === uploadTypes.JSON && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/import-data-from-json/${uuid}`}
                      className="nav-link"
                      title="Import From JSON FILE"
                    >
                      <img src={jsonImage} alt="JSON" className="mb-1" />
                      &nbsp;JSON
                    </Link>
                  </li>
                  &nbsp; &nbsp;
                  <li className={`nav-item ${label === uploadTypes.REST_API && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/import-from-restapi/${uuid}`}
                      className="nav-link"
                      title="Import From REST API"
                    >
                      <i className="wb webconnect-rocket"></i>
                      &nbsp;REST&nbsp;API
                    </Link>
                  </li>
                  &nbsp; &nbsp;
                  <li className={`nav-item ${label === uploadTypes.DB_DUMP && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/import-dump/${uuid}?collectionName=${collectionTitle}`}
                      className="nav-link"
                      title="Import From DATABASE DUMP"
                    >
                      <i className={`wb webconnect-database`}></i> DrapCode&nbsp;DUMP
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className={`nav-item ${label === types.FIELDS && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/edit/${uuid}`}
                      className="nav-link"
                    >
                      <i className={`wb ${drapcodeIcon('fields')}`}></i> Fields
                    </Link>
                  </li>
                  <li className={`nav-item ${label === types.CONSTRUCTOR && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/constructors/${uuid}`}
                      className="nav-link"
                    >
                      <i className={`wb ${drapcodeIcon('constructors')}`}></i> Constructors
                    </Link>
                  </li>
                  <li className={`nav-item ${label === types.DERIVED_FIELD && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/derived-fields/${uuid}`}
                      className="nav-link"
                    >
                      <i className={`wb ${drapcodeIcon('derivedFields')}`}></i> Derived Fields
                    </Link>
                  </li>
                  {restrictEdit && collectionName !== 'role' ? (
                    ''
                  ) : (
                    <li className={`nav-item ${label === types.FILTER && 'active'}`}>
                      <Link
                        to={`/collections/${version}/v/${projectId}/filters/${uuid}`}
                        className="nav-link"
                      >
                        <i className={`wb ${drapcodeIcon('filters')}`}></i> Filters
                      </Link>
                    </li>
                  )}
                  <li
                    className={`nav-item ${
                      [types.PERMISSION_LEVEL_SECURITY, types.ROW_LEVEL_SECURITY].includes(label) &&
                      'active'
                    }`}
                  >
                    <UncontrolledDropdown>
                      <DropdownToggle
                        caret
                        title="Security"
                        color={`${
                          [types.PERMISSION_LEVEL_SECURITY, types.ROW_LEVEL_SECURITY].includes(
                            label,
                          )
                            ? 'theme-green--dropdown'
                            : 'theme-primary--dropdown'
                        }`}
                        className="btn-md font-s-12"
                      >
                        <i className={`wb webconnect-lock`}></i> Security
                      </DropdownToggle>
                      <DropdownMenu flip>
                        <DropdownItem>
                          <Link
                            to={`/collections/${version}/v/${projectId}/permission-level-security/${uuid}`}
                            title="Permission Level Security"
                            className="no-hover"
                          >
                            <i className={`wb ${drapcodeIcon('permissionLevelSecurity')}`}></i>{' '}
                            Permission Level Security
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link
                            to={`/collections/${version}/v/${projectId}/row-level-security/${uuid}`}
                            title="Row Level Security"
                            className="no-hover"
                          >
                            <i className={`wb ${drapcodeIcon('rowLevelSecurity')}`}></i> Row Level
                            Security
                          </Link>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </li>
                  <li
                    className={`nav-item ${
                      [types.TYPESENSE_MAPPING, types.COLLECTION_MAPPING].includes(label) &&
                      'active'
                    }`}
                  >
                    <UncontrolledDropdown>
                      <DropdownToggle
                        caret
                        title="Mappings"
                        color={`${
                          [types.TYPESENSE_MAPPING, types.COLLECTION_MAPPING].includes(label)
                            ? 'theme-green--dropdown'
                            : 'theme-primary--dropdown'
                        }`}
                        className="btn-md font-s-12"
                      >
                        <i className={`wb webconnect-table`}></i> Mappings
                      </DropdownToggle>
                      <DropdownMenu flip>
                        <DropdownItem>
                          <Link
                            to={`/collections/${version}/v/${projectId}/collection-mapping/${uuid}`}
                            title="Collection Mapping"
                            className="no-hover"
                          >
                            <i className={`wb ${drapcodeIcon('collectionMapping')}`}></i> Collection
                            Mapping
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link
                            to={`/collections/${version}/v/${projectId}/typesense-mapping/${uuid}`}
                            title="Typesense Mapping"
                            className="no-hover"
                          >
                            <i className={`wb ${drapcodeIcon('typesenseMapping')}`}></i> Typesense
                            Mapping
                          </Link>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </li>
                  <li className={`nav-item ${label === types.VALIDATION && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/validations/${uuid}`}
                      className="nav-link"
                    >
                      <i className={`wb ${drapcodeIcon('validations')}`}></i> Validations
                    </Link>
                  </li>

                  <li
                    className={`nav-item ${
                      [types.CONSTANT, types.CONSTRAINT, types.WORKFLOW].includes(label) && 'active'
                    }`}
                  >
                    <UncontrolledDropdown>
                      <DropdownToggle
                        caret
                        title="Extra"
                        color={`${
                          [types.CONSTANT, types.CONSTRAINT, types.WORKFLOW].includes(label)
                            ? 'theme-green--dropdown'
                            : 'theme-primary--dropdown'
                        }`}
                        className="btn-md font-s-12"
                      >
                        <i className={`wb webconnect-cogs`}></i> Extra
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem>
                          <Link
                            to={`/collections/${version}/v/${projectId}/constants/${uuid}`}
                            title="Constants"
                            className="no-hover"
                          >
                            <i className={`wb ${drapcodeIcon('constants')}`}></i> Constants
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link
                            to={`/collections/${version}/v/${projectId}/constraints/${uuid}`}
                            title="Constraints"
                            className="no-hover"
                          >
                            <i className={`wb ${drapcodeIcon('constraints')}`}></i> Constraints
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link
                            to={`/collections/${version}/v/${projectId}/workflow/${uuid}`}
                            title="Workflows"
                            className="no-hover"
                          >
                            <i className={`wb ${drapcodeIcon('workflow')}`}></i> Workflows
                          </Link>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </li>
                  {/* <li className={`nav-item ${label === types.INDEXING && 'active'}`}>
                    <Link
                      to={`/collections/${version}/v/${projectId}/indexing/${uuid}`}
                      className="nav-link"
                    >
                      <i className={`wb ${drapcodeIcon('indexing')}`}></i> Indexes
                    </Link>
                  </li> */}
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default CollectionHeaderNav;
